import apiCompetitions from '@/api/competition'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  deleteCompetitionAthletesStart:
    '[delete competition Athletes] Delete competition Athletes start',
  deleteCompetitionAthletesSuccess:
    '[delete competition Athletes] Delete competition Athletes success',
  deleteCompetitionAthletesFailure:
    '[delete competition Athletes] Delete competition Athletes failure',
}

export const actionTypes = {
  deleteCompetitionAthletes:
    '[delete competition Athletes] Delete competition Athletes',
}

const mutations = {
  [mutationTypes.deleteCompetitionAthletesStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteCompetitionAthletesSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteCompetitionAthletesFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.deleteCompetitionAthletes](context, {id}) {
    context.commit(mutationTypes.deleteCompetitionAthletesStart)
    return new Promise((resolve) => {
      apiCompetitions
        .deleteCompetitionAthletes(id)
        .then((response) => {
          context.commit(mutationTypes.deleteCompetitionAthletesSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.deleteCompetitionAthletesFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
